import appStore from 'store'
import api from './api'
import { QUERY_TYPE, PAGINATION } from './constants'

const store = {
  namespaced: true,
  state: {
    userList: [],
    detailList: [],
    coinList: [],
    symbolList: [],
    totalCount: 0,
    detailTotalCount: 0,
    pagination: PAGINATION,
    contactHistory: [],
    totalRealizedProfit: 0,
    totalFee: 0,
    orderBy: null,
    delVisible: false,
    taskTypeList: [],
    logicOpList: [],
    mathOpList: {},
    lotteryList: {},
    userTypeList: [],
  },
  getters: {
    taskTypeListOptions: (state) => {
      const uniqueIds = new Set(
        state.taskTypeList.map((item) => item.activityModule)
      )
      const uniqueData = []
      uniqueIds.forEach((activityModule) => {
        const item = state.taskTypeList.find(
          (item) => item.activityModule === activityModule
        )
        uniqueData.push(item)
      })

      return uniqueData
    },
    taskTypeMap: (state) => {
      return state.taskTypeList.reduce((groups, item) => {
        if (!groups[item.activityModule]) {
          groups[item.activityModule] = []
        }
        groups[item.activityModule].push(item)
        return groups
      }, {})
    },
    mathOpListArr: (state) => {
      return Object.entries(state.mathOpList).map(([key, value]) => ({
        label: value,
        value: key,
      }))
    },
    logicOpListArr: (state) => {
      return Object.entries(state.logicOpList).map(([key, value]) => ({
        label: key,
        value: key,
      }))
    },
  },
  mutations: {
    // setUserList(state, payload) {
    //   state.userList = payload.list.slice()
    //   state.totalCount = payload.totalCount
    // },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setDetailList(state, payload) {
      state.detailList = payload.list ? payload.list.slice() : []
      state.detailTotalCount = payload.totalCount
    },
    setCoinList(state, payload) {
      state.coinList = payload || []
    },
    setSymbolList(state, payload) {
      state.symbolList = payload || []
    },
    setContactHistory(state, payload) {
      state.contactHistory = payload.items
      state.totalCount = payload.total
    },
    setContactHistoryInfo(state, payload) {
      state.totalRealizedProfit = payload ? payload.totalRealizedProfit : 0
      state.totalFee = payload ? payload.totalFee : 0
    },
    setOrderBy(state, payload) {
      state.orderBy = payload
    },
    setDelVisible(state, payload) {
      state.delVisible = payload
    },
    setTaskType(state, payload) {
      state.taskTypeList = payload
    },
    setLogicOp(state, payload) {
      state.logicOpList = payload
    },
    setMathOp(state, payload) {
      state.mathOpList = payload
    },

    setLotteryList(state, payload) {
      state.lotteryList = payload.items
    },
    setUserTypeList(state, payload) {
      state.userTypeList = payload
    },
  },
  actions: {
    getHistory({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      api.getHistory(query).then((res) => {
        if (res.code == 0) {
          commit('setContactHistory', res.data)
        }
      })
    },
    getHistoryInfo({ commit }, data) {
      return api.getHistoryInfo(data).then((res) => {
        if (res.code == 0) {
          commit('setContactHistoryInfo', res.data)
        }
      })
    },
    exportExcel({ commit }, data) {
      return api.exportExcel(data).then((res) => {
        return res
      })
    },
    addRemark({ commit }, data) {
      return api.addRemark(data).then((res) => {
        return res
      })
    },

    getDetail({ commit }, data) {
      api.getDetail(data).then((res) => {
        if (res.code == 0) {
          commit('setDetailList', res.result)
        }
      })
    },
    getCoinList({ commit }, data) {
      api.getCoinList().then((res) => {
        if (res.code == 0) {
          commit('setCoinList', res.result)
        }
      })
    },
    getSymbolList({ commit }, data) {
      api.getSymbolList().then((res) => {
        if (res.code == 0) {
          commit('setSymbolList', res.data)
        }
      })
    },
    delPositionId({ commit }, { positionId }) {
      api.delPositionId(positionId).then((res) => {
        if (res.code == 0) {
          commit('setSymbolList', res.data)
        }
      })
    },
    addLottery({ commit }, data) {
      return api.addLottery(data).then((res) => {
        return res
      })
    },
    getTaskType({ commit }) {
      api.getTaskType().then((res) => {
        if (res.code == 0) {
          commit('setTaskType', res.data)
        }
      })
    },
    getLogicOp({ commit }) {
      api.getLogicOp().then((res) => {
        if (res.code == 0) {
          commit('setLogicOp', res.data)
        }
      })
    },
    getMathOp({ commit }) {
      api.getMathOp().then((res) => {
        if (res.code == 0) {
          commit('setMathOp', res.data)
        }
      })
    },
    getLotteryList({ commit }, data) {
      api.getLotteryList(data).then((res) => {
        if (res.code == 0) {
          commit('setLotteryList', res.data)
        }
      })
    },
    getUserTypeList({ commit }, data) {
      api.getUserTypeList(data).then((res) => {
        if (res.code == 0) {
          commit('setUserTypeList', res.data)
        }
      })
    },
    getActive({ commit }, data) {
      return api.getActive(data).then((res) => {
        return res
      })
    },
  },
}

appStore.registerModule('management', store)
